import bgBlue from './offer_blue.jpg';
import bgPurple from './offer_purple.jpg';
import bgRed from './offer_red.jpg';

export default {
  bgBlue,
  bgPurple,
  bgRed,
};
